import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { IndexedStoreApplicant, StoreApplicant } from '@funnels/types';

function createApplicantsGroups(applicants: StoreApplicant[], sort = (a: any, b: any) => 0) {
  const groupedApplicants: IndexedStoreApplicant[][] = [];
  const calculatedApplicantIds: string[] = [];
  const indexedApplicants = applicants.map((a, index) => ({ ...a, applicantIndex: index }));

  indexedApplicants.forEach((a: IndexedStoreApplicant) => {
    const formValue = { applicants: [a] };
    const maritalStatus = get(formValue, FIELD_PATHS.APPLICANT_MARITAL_STATUS(0));
    const marriedApplicantId = get(formValue, FIELD_PATHS.APPLICANT_MARITAL_DETAILS_APPLICANT_ID(0));
    /* Group condition 1 (2 applicants)
     *  applicant is married or defacto, and there is an related applicant id.
     */
    if ((maritalStatus === FIELD_VALUES.DE_FACTO || maritalStatus === FIELD_VALUES.MARRIED) && marriedApplicantId) {
      /* Group condition
       *  Both applicants have not been inclued in the group.
       */
      if (!calculatedApplicantIds.includes(a.id || '') && !calculatedApplicantIds.includes(marriedApplicantId)) {
        const group = [a];
        const marriedApplicant = indexedApplicants.find((applicant) => applicant.id === marriedApplicantId);
        if (marriedApplicant) {
          group.push(marriedApplicant);
        }
        groupedApplicants.push(group);
      }
      /* Group condition 2 (1 applicant)
       *  applicant is having other relationship type, or having a data issue(missing related applicant id).
       */
    } else {
      /* Group condition
       *  The applciant has not been inclued in the group.
       */
      if (!calculatedApplicantIds.includes(a.id || '')) {
        groupedApplicants.push([a]);
      }
    }
    calculatedApplicantIds.push(a.id || '');
  });
  return groupedApplicants.sort(sort);
}

function getFollowingApplicantGroups(applicants: StoreApplicant[], currentApplicantId: string) {
  const groupedApplicants: IndexedStoreApplicant[][] = createApplicantsGroups(applicants);
  let currentApplicantGroupIndex = -1;

  groupedApplicants.forEach((group: IndexedStoreApplicant[], index: number) => {
    if (group.map((a) => a.id).includes(currentApplicantId)) {
      currentApplicantGroupIndex = index;
    }
  });
  // There is no next applicant group, or other errors
  if (currentApplicantGroupIndex === -1 || currentApplicantGroupIndex === groupedApplicants.length) {
    return [];
  }
  return groupedApplicants.slice(currentApplicantGroupIndex + 1);
}

function getLeadApplicantIdFromNextGroup(applicants: StoreApplicant[], currentApplicantId: string) {
  const followingApplicantGroups = getFollowingApplicantGroups(applicants, currentApplicantId);
  if (followingApplicantGroups.length > 0) {
    return followingApplicantGroups[0][0].id;
  }
  return;
}

export { getLeadApplicantIdFromNextGroup, createApplicantsGroups, getFollowingApplicantGroups };
